import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { HwtButton } from '../Buttons/HwtButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { useModal } from '@lwtears/lwt-common-frontend/lib/Modal';
import { translate } from 'translations/translator';
import ModalsTranslationVariant from 'translations/variants/modals';
const { yesRemove, cancel, removeAllDescription1, removeAllDescription2 } =
  ModalsTranslationVariant;

type Props = {
  activityName: string;
  handleOnRemove: () => void;
};
const getTranslation = (key: ModalsTranslationVariant, options?) =>
  translate('modals', key, options);
export const RemoveActivityModal = ({ activityName, handleOnRemove }: Props) => {
  const [, { closeModal }] = useModal();
  const theme = useTheme();
  const classes = useStyles()();

  const withCloseModal = cb => () => {
    cb();
    closeModal();
  };
  return (
    <Box className={classes.container}>
      <Box>
        <Typography variant="h6">
          {getTranslation(ModalsTranslationVariant.removeAllActivities, { name: activityName })}
        </Typography>
      </Box>
      <Typography variant="body1">
        {`${getTranslation(removeAllDescription1)} "${activityName}" ${getTranslation(
          removeAllDescription2
        )} `}
      </Typography>
      <Box className={classes.actionItem}>
        <HwtButton onClick={closeModal} variant="outlined">
          {getTranslation(cancel)}
        </HwtButton>
        <HwtButton
          onClick={withCloseModal(handleOnRemove)}
          variant="contained"
          style={
            {
              backgroundColor: theme.palette.error.main,
              '&:hover': {
                backgroundColor: theme.palette.error.light
              }
            } as any
          }
        >
          <FontAwesomeIcon icon={faPlusCircle} style={{ marginRight: '10px', fontSize: '14px' }} />
          {getTranslation(yesRemove)}
        </HwtButton>
      </Box>
    </Box>
  );
};

const useStyles = () =>
  makeStyles(() => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      justifyContent: 'space-around',
      alignItems: 'center',
      height: '243px',
      width: '600px',
      padding: '10px 32px',
      backgroundColor: '#fff'
    },
    actionItem: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%'
    }
  }));
